export default __webpack_public_path__ + "static/media/meditation.4c0e0418.png";